import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IRequestRegioes } from './types';

// ACTIONS
import { regioesSuccess, regioesFailure } from './actions';

function* regioes(request: ReducerAction) {
	const { payload }: { payload: IRequestRegioes } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`divisao-equitativa/${CHANNEL}/regioes`,
		payload,
	);

	if (response.status === 200) {
		yield put(regioesSuccess(response));
	} else if (response.error) {
		yield put(regioesFailure(response.error));
	}
}

export default all([takeLatest(Types.REGIOES, regioes)]);
